import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX, Play } from "lucide-react";
import api, { API } from "@/lib/api";
import { abVariant, setAbVariant, abEvent } from "@/lib/ab";

// Landing hero: the promo video set by an admin (slot A or B → sticky A/B split), autoplay muted with a "play with sound" toggle.
export default function HeroVideo({ fallback = null, compact = false }) {
  const [hero, setHero] = useState(undefined);
  const [variant, setVariant] = useState(null);
  const [muted, setMuted] = useState(true);
  const ref = useRef(null);
  useEffect(() => {
    const stored = abVariant();
    let first = false;
    try { first = !sessionStorage.getItem("mf_ab_imp"); if (first) sessionStorage.setItem("mf_ab_imp", "1"); } catch { /* noop */ }
    api.get(`/promo/hero${stored ? `?v=${stored}` : ""}`).then(({ data }) => {
      setHero(data.hero);
      setVariant(data.variant);
      if (data.variant) { setAbVariant(data.variant); if (first) abEvent("impression"); }
    }).catch(() => setHero(null));
  }, []);
  if (hero === undefined) return null;
  if (!hero) return fallback;
  const base = API.replace(/\/api$/, "");
  const withSound = () => {
    const v = ref.current;
    if (!v) return;
    if (muted) { v.currentTime = 0; v.muted = false; v.play().catch(() => {}); setMuted(false); abEvent("play"); }
    else { v.muted = true; setMuted(true); }
  };
  const square = hero.format === "square", vertical = hero.format === "vertical";
  return (
    <div className={`relative group ${compact ? "w-full" : vertical ? "w-[300px]" : square ? "w-[440px]" : "w-[620px]"}`} data-testid="hero-video-wrap" data-variant={variant || undefined}>
      <video ref={ref} src={`${base}${hero.video_url}`} poster={`${base}${hero.poster_url}`} autoPlay muted={muted} loop playsInline preload="metadata"
        className={`w-full rounded-2xl border border-primary/30 bg-black shadow-[0_0_60px_rgba(124,58,237,0.35)] ${vertical ? "aspect-[9/16]" : square ? "aspect-square" : "aspect-video"}`} data-testid="hero-video" />
      <button type="button" onClick={withSound} className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 rounded-full bg-background/80 backdrop-blur border border-primary/40 text-primary text-xs font-medium px-3 py-1.5 hover:bg-primary hover:text-primary-foreground transition-colors" data-testid="hero-video-sound">
        {muted ? <><Play size={12} /> <Volume2 size={12} /> Lire avec le son</> : <><VolumeX size={12} /> Couper le son</>}
      </button>
      <span className="absolute top-3 left-3 text-[10px] font-mono px-2 py-0.5 rounded-full bg-background/70 border border-border text-muted-foreground">GENERATE. ADAPT. PLAY.</span>
    </div>
  );
}
